define('views/transfer/friends-and-family',[
    'views/_base/baseview',
    'text!views/transfer/friends-and-family.html',
	'views/transfer/searched-user',
	'models/transfer/user_search_collection',
	'models/transfer/suggestions_collection'
], function(BaseView, Template, SearchedUserView, UserSearchModel, RecentUserSuggestionsModel){
    'use strict';

    return BaseView.extend({
		tagName  : 'div',
		className: 'transfer-to-friends-container', 
		isRender : true,
		template : _.template(Template),
		events   : {
			'focus #friends-search' : 'toggleSuggestionsMODAL',
			'blur #friends-search'  : 'toggleSuggestionsMODAL',
			// 'click .search-list li' : 'populateParentViewFieldsMODAL',
			'submit .js-search-form': 'submitSearchMODAL',
			'keyup #friends-search' : 'toggleClearMODAL',
			'click .cancel-search'  : 'clearSearchFieldMODAL',

			// MODAL
			'click #pf-modal-close-btn' : 'closeMODAL'
		},
        initialize: function(options){
			options = options || {};
			
			this.parentView = options.parentView;
			this.recent_suggestions_header = pf.getContent('transfer.content.friends_and_family.recent_suggestions_header');
			this.user_search_header = pf.getContent('transfer.content.friends_and_family.user_search_header');

			this.elementName = options.elementName;

			BaseView.prototype.initialize(this);
        },

		render: function(){
			
			this.$el.html(this.template());
			
			this.getSuggestions();
			
			return this;
		},

		getSuggestions: function(){
			var that = this;
			
			this.recent_user_suggestions = new RecentUserSuggestionsModel({
				UGID : pf.session.get('UserGUID'),
				limit: 10
			});

			$('#results').empty();
			
			this.recent_user_suggestions.fetch({
				success: function(response){
					
					if(response.length == 0){
						$('.js-search-results-header').html('');
					} else {
						$('.js-search-results-header').html(that.recent_suggestions_header);
					}
					
					that.addAllMODAL(response);
				},
				error: function(err){
					console.error('error fetching suggestions');
				}
			});
			
		},

		toggleClearMODAL: function(e){
			
			if(_.isEmpty($(e.currentTarget).val())){
				this.$('.cancel-search').addClass('hidden');
			} else {
				this.$('.cancel-search').removeClass('hidden');
			}
			
			$('.recent-searches').addClass('hidden');
			
		},

		toggleSuggestionsMODAL: function(e){
			var event_type = e.type,
				suggestions_container = this.$('.recent-searches');
			
			if(event_type === 'focusin'){
				suggestions_container.addClass('hidden');
			} else if (event_type === 'focusout' && _.isEmpty($('#friends-search').val())) {
				suggestions_container.removeClass('hidden');
			}

		},
		
		populateParentViewFieldsMODAL: function(user){
			var name = user.first_name + ' ' + user.last_name,
				entity_type_id = (user.entity_type_id) ? user.entity_type_id : enums.entityTypeEnum.Consumer,
				parent_view = (this.parentView) ? this.parentView : this.calling_view.parentView;

			parent_view.handleTransferToSelection(name);
			
			parent_view.transfer.to = {
            	account_id 	  : user.user_guid,
            	entity_type_id: entity_type_id
            };
			
			this.closeMODAL();
		},
		
		submitSearchMODAL: function(e){
			if(e && e.preventDefault){ e.preventDefault(); }
            if(e && e.stopPropagation){ e.stopPropagation(); }

			var that = this,
				search_value = this.$('#friends-search').val();
							
			that.user_search_collection = new UserSearchModel({
				limit      : 40,
				search_data: encodeURIComponent(search_value)
			});

			$('#results').empty();
			
			$('#search-results-container').removeClass('hidden');
			$('.list-loading').removeClass('hidden');
			
			
			that.user_search_collection.fetch({
				type: 'GET',
				// begin temp fix
				beforeSend: function(xhr){
					xhr.setRequestHeader('authorization',pf.session.get('UserGUID'));
				},
				headers: {
					'x-api-key': pf.apikey.toUpperCase()
				},
				// end temporary fix
				success: function (success) {
					// console.log('success',that, success);
					$('.js-search-results-header').html(that.user_search_header);
					$('.list-loading').addClass('hidden');
					that.addAllMODAL(success);
				},
				error: function (err) {
					
					$('.list-loading').addClass('hidden');

					if(err.statusText == 'Not Found' && err.status == '404'){
						$('#results').append('<li>No results</li>');
					}
				}
			});
		},
		
		addAllMODAL: function(models){
			var that = this;
			models.forEach(this.addOneMODAL, that);
		},
		
		addOneMODAL: function(model){
						
			var searched_user_view = new SearchedUserView({
				user 	   : model.toJSON(),
				parent_view: this
			});
			
			$('#results').append(searched_user_view.$el);
		},
		
		clearSearchFieldMODAL: function(e){
			var input = this.$('#friends-search').select().val('');
			$(e.currentTarget).addClass('hidden');
			$('#results').empty();
			$('#search-results-container').addClass('hidden');
			this.$('.recent-searches').removeClass('hidden');
			
		},
		
		closeMODAL: function(){
            $('#pf-modal-modern').fadeOut(function(){
                $('#pf-modal-modern').remove();
            });
        },

        close: function(){}
    });
});

